// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__4u3uK","cards":"styles_cards__NGKPg","iconWrapper":"styles_iconWrapper__4b6cl"};